import { Button } from "@models/configurators/button";
import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IDropdownButton } from "@models/entity-models";

@Kbo(CToken.DropdownButton)
export class DropdownButton extends Button implements IDropdownButton {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    private _buttons: Button[];
    @Enumerable()
    public get buttons(): Button[] {
        if (!this._buttons) this._buttons = [];
        return this._buttons;
    }
    public set buttons(val) {
        this._buttons = val;
    }
    
    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.buttons
        );
    }

    public allowedChildren(rootType: CToken): CToken[] {
        return [
            CToken.Button
        ];
    }
}
